import React, { Fragment } from 'react';
import { AutoComplete, Button, Form, Input, Modal, notification, Select, Typography } from "antd";
import ApiService from "../../../services/ApiService";
import { t } from "@lingui/core/macro";
import { Trans } from "@lingui/react/macro";

const { Search } = Input;
const { Text } = Typography;
const { Option } = Select;

export default class ModalAddEmail extends React.Component {

    constructor(props) {
        super(props);
        props.getRef(this)
    }

    initialState = {
        visible: false,
        loading: false,
        contactId: null,
        adresses: [],
        id: null,
        edit: false,
        defaultData: {}
    };

    state = this.initialState;

    async show(contactId, data = {}, adresses = []) {
        if (data.id) {
            this.setState({
                visible: true,
                edit: true,
                adresses: adresses,
                contactId: contactId,
                id: data.id,
                defaultData: { ...data }
            })
        } else {
            this.setState({ visible: true, adresses: adresses, contactId: contactId })
        }
    }

    close() {
        this.setState(this.initialState)
    }

    async onSubmit(data) {
        if (this.state.id) {
            data.id = this.state.id
        }

        this.setState({ loading: true })

        var res = await ApiService.post("/contact/email/edit/" + this.state.contactId, data)

        if (res.success) {
            if (res.message) {
                notification.warn({
                    message: res.message
                })
            } else {
                notification.success({
                    message: this.state.edit ? t`Succès de la modification` : t`Succès de l'ajout`
                })
            }

            this.close()
            if (this.props.onFinish) {
                this.props.onFinish(res.data)
            }
        } else {
            notification.error({
                message: this.state.edit ? t`Erreur lors de la modification` : t`Erreur lors de l'ajout`
            })
        }

        this.setState({ loading: false })
    }

    render() {
        return (
            <Modal
                width="100%"
                title={this.state.id ? t`Éditer une adresse email` : t`Ajouter une adresse email`}
                open={this.state.visible}
                destroyOnClose
                closable
                footer={null}
                onCancel={() => this.close()}
            >
                <Form
                    onFinish={(data) => this.onSubmit(data)}
                    ref={(ref) => this.form = ref}
                    layout={"vertical"}
                    initialValues={this.state.defaultData}
                >
                    <Form.Item
                        label={<Trans>Type d'adresse email</Trans>}
                        name="type"
                        rules={[{ required: true, message: t`Ce champ est obligatoire` }]}
                    >
                        <AutoComplete
                            options={[t`Domicile`, t`Société`, t`Bureau`, t`Autre`].map(i => ({ value: i }))}
                            filterOption={(inputValue, option) =>
                                option.value.toUpperCase().indexOf(inputValue.toUpperCase()) !== -1
                            }
                        >
                            <Input placeholder={t`Type d'adresse email`} />
                        </AutoComplete>
                    </Form.Item>

                    <Form.Item
                        label={<Trans>Email</Trans>}
                        name="email"
                        rules={[{ required: true, message: t`Ce champ est obligatoire` }]}
                    >
                        <Input type="email" placeholder={t`Email`} />
                    </Form.Item>

                    {this.state.adresses.length > 0 && (
                        <Form.Item
                            label={<Trans>Adresse</Trans>}
                            name="adresseId"
                        >
                            <Select style={{ width: "100%" }} placeholder={t`Lier avec une adresse`}>
                                {this.state.adresses.map(i => (
                                    <Select.Option key={i.id} value={i.id}>
                                        {i.siren ? (
                                            <Fragment>
                                                <Trans>Société</Trans>: {i.nom} ({i.siren}) - {i.adresse}, {i.postal}, {i.ville}, {i.pays}
                                            </Fragment>
                                        ) : (
                                            <Fragment>
                                                {i.nom} - {i.adresse}, {i.postal}, {i.ville}, {i.pays}
                                            </Fragment>
                                        )}
                                    </Select.Option>
                                ))}
                            </Select>
                        </Form.Item>
                    )}

                    <Form.Item style={{ display: "flex", justifyContent: "flex-end" }}>
                        <Button type="primary" htmlType="submit" loading={this.state.loading}>
                            <Trans>Valider</Trans>
                        </Button>
                    </Form.Item>
                </Form>
            </Modal>
        )
    }
}
